define({
  clickSignUp:
    'Click "Enroll Now" to automatically open ClassIn to get enrolled </br>or manually open ClassIn and search for the public course by ID',
  copyPublessonId: 'Click to copy ID',
  pressPublessonId: 'Hold to copy ID',
  publessonId: 'Public Class ID:',
  institution: 'School Intro',
  cellphoneNumber: 'Enter a mobile number',
  verificationCode: 'Captcha',
  smsVerification: 'SMS verification',
  enter6To20Pwd: 'Enter a password of 6-20 bits',
  readUserAgm:
    'I have read and agree to <a class="is-link" href="//www.eeo.cn/s/agreement/?type=user&lang=en" target="_blank">ClassIn User Agreement</a>',
  downTip: 'Please download ClassIn after enrollment and log in with this mobile number and password to take the class',
  apply: 'Enroll',
  applyNow: 'Join Now',
  applied: 'Enrolled',
  success: 'Enrolled successfully',
  end: 'Enrollment has ended',
  full: 'Class is full',
  down: 'Download ClassIn',
  downLoadTip: 'Haven\'t downloaded ClassIn yet? <span style="color: #009265;">Download Now</span>',
  applyPublesson: 'Enroll in Public Course (meeting)',
  teacher: 'Head teacher:',
  duration: 'Duration:',
  minute: 'Clock',
  share: {
    title1: '[Public Course Enrollment] {lessonName} | {schoolName}',
    des: '{teacher} starts live teaching at {time} [{schoolName}]',
    title2: '[Public Course Enrollment] {lessonName} starts live teaching at {time} [{schoolName}]',
  },
  subtitle: {
    downAndinstall:
      'Please download ClassIn and <span style="color:#f66656;font-weight: bold;">log in with your account and password to join classes.</span>',
    downAndReady: 'Please download and install ClassIn to prepare for the next public course.',
  },
  placeholder: {
    phoneNumber: 'Mobile number / email address',
    nickName: 'Name',
    verCode: 'Code',
    msmCode: 'SMS verification',
    password: 'Enter a 6-20 bit password',
  },
  form: {
    sendMsg: 'Get',
    reSend: 'Resend in {num}s',
  },
  downloadImg: {
    scanCode: 'Scan the QR code join the public course',
    save: 'Press and hold to save image',
    lessonId: 'Public course ID:',
    startTime: 'Class Time:',
    teacher: 'Teacher: ',
  },
  tip: {
    deleted: 'This public course has been deleted. Please contact the customer service.',
    institutionDisabled: 'This school has stopped service. Please contact the customer service.',
    noAddStu: 'School account cannot be added as a student',
    assistant: 'You are already an assistant of this public course',
    teacher: 'You are already a teacher of this public course',
    copySuccess: 'Public course ID copied',
    copyFail: 'Failed to copy',
    browserIos: 'Please visit this page in Safari',
    browserWin: 'This URL cannot be opened in WeChat. Please copy it and open it in the browser.',
    invalid: 'Link has expired. Please contact the school for a valid link to enroll in the public course.',
    isApplied: '{num} enrolled',
    isAppliedMax: 'and {num} enrolled',
  },
  errorMsg: {
    enterPhoneNumber: 'Enter a mobile number',
    enterTruePhoneNumber: 'Enter a correct mobile number',
    // NEW:
    email_tips: 'Enter an email address',
    email_Error: 'Enter a correct email address',
    enterName: 'Enter a name',
    enterNameRule: 'Please enter a name of 2-24 characters',
    enterVerCode: 'Enter verification code',
    enter6To20Pwd: 'Enter a 6-20 digit password',
    pwdHasNumEn: 'Password must contain letters and digits',
    pwdIllegal: 'Password cannot contain illegal characters',
    pwdHasCn: 'Password cannot contain Chinese characters',
    pwdHasEmpty: 'Password cannot contain spaces',
    apiOverrun: 'Number of requests exceeds the limit',
    wrongVerCode: 'Incorrect verification code',
    operateFail: 'Failed',
    phoneIllegal: 'Illegal mobile number',
    sendLimit: 'The number of verification codes sent has reached the upper limit',
    sendfrequently: 'Too frequent verification code requests',
    sendFail: 'Failed to send verification code',
    firstError: 'The first digit cannot be 0',
    100: 'Incomplete or incorrect parameter',
    101: 'Not logged in',
    102: 'No permission',
    108: 'The number of verification codes sent today has reached the upper limit',
    109: 'Too frequent verification code requests',
    110: 'Failed to send verification code. Please try again later.',
    113: 'Mobile number is not registered',
    133: 'Enter a correct email address',
    134: 'Enter a correct mobile number',
    135: 'Mobile number has been registered. Please log in directly.',
    136: 'Email address has been registered. Please log in directly.',
    166: 'This student already exists under the lesson',
    20704: 'A mobile number can be associated with up to 5 ClassIn accounts. Please try again using another mobile number.',
    20718: 'Enter a correct email address',
    20727: 'Too frequent attempts',
    20728: 'Incorrect verification code',
    20729: 'Incorrect verification code',
    20730: 'Too frequent requests. Please try again later',
    20731: 'Too frequent verification code requests',
    20732: 'The number of verification codes sent today has reached the upper limit',
    20733: 'Parameter error. Please try again.',
    20734: 'Failed to send verification code. Please try again later.',
  },
  jumpPage: {
    starting: 'Starting ClassIn...',
    openClassIn: 'Please click "<span style="color:#000;font-weight:bold;">Open ClassIn</span>" in the pop-up window to get enrolled',
    browserDontTip: 'No pop-up in the browser? Please',
    clickThis: 'click here  ',
    searchPublessonId: 'Try again or manually open ClassIn and search with public course ID: {publessonId}',
    dontInstallClassIn: 'ClassIn not installed',
    by: 'Enroll',
    signUpByPhone: 'by mobile number / email address',
    classInPublesson: 'ClassIn Public Course',
  },
})
